/**
 * 画面に出す値の書き方。**2 アプリで同じ形にする**ための 1 か所。
 *
 * ## 時刻は日本時間の読みやすい表記にする
 *
 * API が返すのは ISO 8601 / UTC の文字列で、そのまま出すと
 * `2026-09-19T12:23:45.000Z` になる。使う人は日本時間で仕事をしているので、
 * 画面でそれを読み替えさせない。**端末の時計に合わせない**のは、
 * 別の時間帯の端末から開いたときに数字が変わると、議事録や台帳と
 * 突き合わせられなくなるためである。
 */

const JST_FORMATTER = new Intl.DateTimeFormat("ja-JP", {
  timeZone: "Asia/Tokyo",
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
  hour: "2-digit",
  minute: "2-digit",
  hour12: false,
});

/**
 * 日本時間の `2026/09/19 21:23` 形式。
 *
 * **読めない値はそのまま返す。** 「—」に倒すと、値が無いのか読めなかったのかが
 * 混ざる（値が無いときは呼び出し側が null を出し分ける）。
 */
export function formatJstDateTime(value: string | null | undefined): string {
  if (value == null || value === "") return "";
  const at = new Date(value);
  if (Number.isNaN(at.getTime())) return value;
  return `${JST_FORMATTER.format(at)}`;
}
